(() => {
  const SECTION_SELECTOR = '.oddit-footer-main';

  function initSection(section) {
    const toggles = section.querySelectorAll('[data-footer-accordion] .oddit-footer-main__column-header');

    for (const toggle of toggles) {
      toggle.addEventListener('click', handleToggle);
    }
  }

  function handleToggle(e) {
    const button = e.currentTarget;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  }

  function destroySection(section) {
    const toggles = section.querySelectorAll('[data-footer-accordion] .oddit-footer-main__column-header');

    for (const toggle of toggles) {
      toggle.removeEventListener('click', handleToggle);
    }
  }

  for (const section of document.querySelectorAll(SECTION_SELECTOR)) {
    initSection(section);
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();